module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Bread-687370c27df01d01b1e1f4823bf95125.svg";